import { render } from "./product_view_image_list.vue?vue&type=template&id=11e60668"
import script from "./product_view_image_list.vue?vue&type=script&lang=js"
export * from "./product_view_image_list.vue?vue&type=script&lang=js"
script.render = render

export default script